// React
import React from 'react';
// Material-UI
import { Grid, useMediaQuery } from '@material-ui/core';
// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * Sección destinada a los botones de acción que tendrá el contenedor
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const AccionesContenedor = ({ 
    children,
}) => {
    // Idioma
    
    // Token
    
    // Estados
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'));
    // Paginador

    // Listas
    
    // Funciones
    
    // Otros

    // Vista
    return (
        <Grid item style={{ width: mdUp ? '200px' : '0px', paddingLeft: '10px', textAlign: 'end' }}>
            {children}
        </Grid>
    );
};
